import { Toaster as SonnerToaster } from "sonner";

export interface ToasterProps {
  dir?: "ltr" | "rtl" | "auto";
  position?: "top-left" | "top-center" | "top-right" | "bottom-left" | "bottom-center" | "bottom-right";
}

export function Toaster({ dir, position = "bottom-center" }: ToasterProps) {
  return (
    <SonnerToaster
      dir={dir}
      position={position}
      toastOptions={{ unstyled: true, classNames: { toast: "w-full min-[601px]:max-w-sm" } }}
      style={{ "--width": "24rem", fontFamily: "inherit" } as React.CSSProperties}
    />
  );
}
